import React, { Component } from 'react'

class Screen4A extends Component {

  render() {

    const { entry, addEntry, language, t } = this.props

    return (
      <main>
        <h3>{t(language, 'hateCrimeDetails')}</h3>
        <label>{t(language, 'howYouKnew')}
          <input type="text" value={entry.source} onChange={(e) => addEntry('source', null, e)} />
        </label>

        <h4>{t(language, 'basisWhyHateCrime')}</h4>

        <div className="checkbox">
          <input id="check_1" type="checkbox" onChange={(e) => addEntry('basis', t(language, 'race'), e)} />
          <label htmlFor="check_1">{t(language, 'race')}</label>
        </div>

        <div className="checkbox">
          <input id="check_2" type="checkbox" onChange={(e) => addEntry('basis', t(language, 'faith'), e)} />
          <label htmlFor="check_2">{t(language, 'faith')}</label>
        </div>

        <div className="checkbox">
          <input id="check_3" type="checkbox" onChange={(e) => addEntry('basis', t(language, 'ethnicity'), e)} />
          <label htmlFor="check_3">{t(language, 'ethnicity')}</label>
        </div>

        <div className="checkbox">
          <input id="check_4" type="checkbox" onChange={(e) => addEntry('basis', t(language, 'language'), e)} />
          <label htmlFor="check_4">{t(language, 'language')}</label>
        </div>

        <div className="checkbox">
          <input id="check_5" type="checkbox" onChange={(e) => addEntry('basis', t(language, 'invalidDisability'), e)} />
          <label htmlFor="check_5">{t(language, 'invalidDisability')}</label>
        </div>

        <div className="checkbox">
          <input id="check_6" type="checkbox" onChange={(e) => addEntry('basis', t(language, 'gender'), e)} />
          <label htmlFor="check_6">{t(language, 'gender')}</label>
        </div>

        <div className="checkbox">
          <input id="check_7" type="checkbox" onChange={(e) => addEntry('basis', t(language, 'sexualOrientationOption'), e)} />
          <label htmlFor="check_7">{t(language, 'sexualOrientationOption')}</label>
        </div>

        <div className="checkbox">
          <input id="check_8" type="checkbox" onChange={(e) => addEntry('basis', t(language, 'genderIdentity'), e)} />
          <label htmlFor="check_8">{t(language, 'genderIdentity')}</label>
        </div>

      </main>
    );
  }
}

export default Screen4A;
